import { GlobalContext, GlobalContextProvider } from "./global";
import { useContext } from "react";

export function useGlobalContext() {
  const context = useContext(GlobalContext);
  if (!context)
    throw new Error(
      "useGlobalContext must be used in " + GlobalContext.displayName,
    );
  return context;
}

export { GlobalContextProvider };
